import { setZoomValueType, zoomSliderLevels } from './ZoomConstants';

export function setZoomValue(key, value = zoomSliderLevels.defaultValue) {
  return {
    type: setZoomValueType,
    payload: {
      key,
      value,
    },
  };
}
